// BURGER

const burger = document.getElementById('burger');
const header = document.getElementById('header');
burger.addEventListener('click', () => {
  header.classList.toggle('open');
})

// SLIDER
const heroSlider = document.getElementById('heroSlider');
if(heroSlider){
    $('#heroSlider').slick({
        infinite: false,
        slidesToShow: 5.3,
        slidesToScroll: 1,
        nextArrow: $('#heroSliderNext'),
        prevArrow: $('#heroSliderPrev'),
        responsive: [
            {
                breakpoint: 2200,
                settings: {
                  slidesToShow: 4.2
                }
              },
              {
                breakpoint: 1850,
                settings: {
                  slidesToShow: 3.6
                }
              },

              {
                breakpoint: 1650,
                settings: {
                  slidesToShow: 3.2
                }
              },
              {
                breakpoint: 1340,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1190,
                settings: {
                  slidesToShow: 2.8
                }
              },
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2.2,
                  slidesToScroll: 2
                }
              },
          ]
    });;
}

const clientsSlider = document.getElementById('clientsSlider');
if(clientsSlider){
    $('#clientsSlider').slick({
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 7,
        nextArrow: $('#clientsSliderNext'),
        prevArrow: $('#clientsSliderPrev'),
        responsive: [
            {
                breakpoint: 1650,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6,
                }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
              }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
      },
      {
        breakpoint: 490,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
    },
        ]
    });;
}

//TABS 

const tabs = document.getElementById('tabs');
if(tabs){
  const tabsNavItems = tabs.querySelectorAll('.tabs__nav ul li');
  const tabsItems = tabs.querySelectorAll('.tabs__items');
  let _showed = false;

  tabsNavItems.forEach((el, i) => {

    if(tabsItems[i].childNodes.length > 1){
      el.addEventListener('click', () => {
        tabs.querySelector('.tabs__nav ul li.active').classList.remove('active');
        tabs.querySelector('.tabs__items.show').classList.remove('show');
        el.classList.add('active');
        tabsItems[el.getAttribute('data-items')].classList.add('show');
      })

      //show first existing tab
      if(!_showed){
        el.classList.add('active');
        tabsItems[i].classList.add('show');
        _showed = true;
      }
    }

    //remove empty tabs
    else{
      el.remove();
    }

  })

  //remove section if no tabs
  if(!_showed){
    document.getElementById('tabs').remove();
  }

}

// PRODUCT TABS

const productTabs = document.getElementById('productTabs');
if(productTabs){
  const productTabsNavItems = productTabs.querySelectorAll('.product__tabs ul li');
  const productTabsItems = productTabs.querySelectorAll('.product__tab');

  productTabsNavItems.forEach((el) => {
    el.addEventListener('click', () => {
      productTabs.querySelector('.product__tabs ul li.active').classList.remove('active');
      productTabs.querySelector('.product__tab.show').classList.remove('show');
      el.classList.add('active');
      productTabsItems[el.getAttribute('data-items')].classList.add('show');
    })
  })
}

// FAQ CLICK

const faqItems = document.querySelectorAll('.product__faq li');
faqItems.forEach((el) => {
  el.addEventListener('click', () => {
    el.classList.toggle('active');
  })
})

//IMG CLICK

function initImageClick() {
  const imagesClick = document.querySelectorAll('img[data-enlargeable]');
  const nav = document.getElementById('modalNav');
  const prev = document.getElementById('modalPrev');
  const next = document.getElementById('modalNext');

  $('img[data-enlargeable]').click(function(e){
      var src = $(this).attr('src');
      var modal;
      var indexImagesClick;
      imagesClick.forEach((el, index) => {
         if(el.getAttribute('src') == $(this).attr('src')){
              indexImagesClick = index;
         };
      });
      nav.classList.add('show');
      next.addEventListener('click', navModalNext);
      prev.addEventListener('click', navModalPrev);
      document.body.addEventListener('keydown', keyDown);
      function keyDown(e){ 
          e.preventDefault();
          var keynum;
          if(window.event) { // IE                    
            keynum = e.keyCode;
          } else if(e.which){ // Netscape/Firefox/Opera                   
            keynum = e.which;
          } 

          if(keynum == 37 || keynum == 38){
              navModalPrev();
          }
          if(keynum == 39 || keynum == 40){
              navModalNext();
          }
      };
      function removeModal(){ modal.remove(); $('body').off('keyup.modal-close'); nav.classList.remove('show'); next.removeEventListener('click', navModalNext); prev.removeEventListener('click', navModalPrev);}
      function navModalNext(){ modal.remove(); indexImagesClick++; if(indexImagesClick == imagesClick.length){ indexImagesClick = 0 }; createModal(imagesClick[indexImagesClick].getAttribute('src'));}
      function navModalPrev(){ modal.remove(); indexImagesClick--; if(indexImagesClick == -1){ indexImagesClick = imagesClick.length -1 }; createModal(imagesClick[indexImagesClick].getAttribute('src'));}
      function createModal(source) {
          modal = $('<div class="modal__bg">').css({
              background: 'url('+source+') no-repeat center',
              backgroundSize: 'contain',
              width:'100%', height:'100%',
              position:'fixed',
              zIndex:'100',
              top:'0', left:'0',
              cursor: 'zoom-out'
          }).click(function(){
              removeModal();
          }).appendTo(nav);
      }

      createModal(src);
      //handling ESC
      $('body').on('keyup.modal-close', function(e){
        if(e.key==='Escape'){ removeModal(); } 
      });
  });
}

//VIDEO CLICK

function initVideoClick() {
  const modal = document.getElementById('video-modal');

  if(!modal) return;

  const frame = modal.querySelector('iframe');

  let videosTriggers = document.querySelectorAll('a[data-triggervideo]');

  videosTriggers.forEach((el) => {
      el.addEventListener('click', () => {
          modal.classList.add('active');
          frame.src = 'https://www.youtube.com/embed/' + el.getAttribute('data-src');
      })
  })

  modal.addEventListener('click', () => {
      modal.classList.remove('active');
      frame.src = null;
  });
}

window.onload = () => {
    initImageClick();
    initVideoClick();
}

$('.timeline-slider').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  nextArrow: $('.timeline__next'),
  prevArrow: $('.timeline__prev'),
  responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
});